import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';
import { BudgetValidationCards } from './types';
import { formatMoney, formatNumber } from './format';

type Props = {
  cards: BudgetValidationCards | null;
};

class BudgetValidationCardsPanel extends React.Component<Props> {
  render() {
    const { cards } = this.props;

    const items = [
      ['Economic Capacity', formatMoney(cards?.economiccapacity)],
      ['Budget Consumption', formatMoney(cards?.budgetconsumption)],
      ['Remaining Capacity', formatMoney(cards?.remainingcapacity)],
      ['Queue Items', formatNumber(cards?.queuecount)],
      ['Requested', formatMoney(cards?.requestedamount)],
      ['Recommended', formatMoney(cards?.recommendedamount)],
      ['Approved', formatMoney(cards?.approvedamount)],
      ['Rejected', formatMoney(cards?.rejectedtotal)],
      ['Reductions', formatMoney(cards?.reductiontotal)],
    ];

    return (
      <Grid container spacing={2}>
        {items.map(([label, value]) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={String(label)}>
            <Card elevation={2}>
              <CardContent>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}

export default BudgetValidationCardsPanel;
